import React, { useState } from 'react';
import styles from './InvoiceSummary.module.css';
import { useQuery } from '@apollo/client';
import { GET_INVOICES } from '../../services/graphql';
import keycloak from '../../keycloak';

const InvoiceSummary = () => {
  const [totalInvoices, setTotalInvoices] = useState(0);
  // const [totalReimbursedAmount, setTotalReimbursedAmount] = useState();
  // const [unpaidAmount, setUnpaidAmount] = useState();


  // useQuery(GET_TOTAL_REIMBURSED_AMOUNT, {
  //   variables: {
  //     userEmail: keycloak.tokenParsed?.email,
  //   },
  //   onCompleted(data) {
  //     setTotalReimbursedAmount(data.getTotalReimbursedAmount.body);
  //   },
  // });


  // function convertAndStringifyFilters() {
  //   const currentDate = new Date();
  //   const currentYear = currentDate.getFullYear();
  //   let currentMonth = currentDate.getMonth() + 1;
  //   const currentDay = currentDate.getDate();
  //   let andFilter = [{}];


  //   // current period starts in this month
  //   if (currentDay >= 15) {
  //     if (currentMonth < 10) {
  //       currentMonth = '0' + currentMonth;
  //     }
  //     andFilter[0].field = 'date';
  //     andFilter[0].operation = 'greater_than_or_equals';
  //     andFilter[0].value = currentYear + '-' + currentMonth + '-' + '15';
  //   }
  //   // current period started previous month
  //   else {
  //     let prevMonth = currentMonth - 1;
  //     if (prevMonth < 10) {
  //       prevMonth = '0' + prevMonth;
  //     }
  //     andFilter[0].field = 'date';
  //     andFilter[0].operation = 'greater_than_or_equals';
  //     andFilter[0].value = currentYear + '-' + prevMonth + '-' + '15';
  //   }
  
  // return JSON.stringify(andFilter);
  // }


// useQuery(GET_TOTAL_UNPAID_AMOUNT, {
//   variables: {
//     userEmail: keycloak.tokenParsed?.email,
//     filter: {
//       andFilter: convertAndStringifyFilters(),
//       orFilter: null,
//     }
//   },
//   onCompleted(data) {
//     setUnpaidAmount(data.getTotalUnpaidAmount.body);
//   },
// });

useQuery(GET_INVOICES, {
  onCompleted(data) {
    setTotalInvoices(data.getInvoices.body.length);
  },
});

return (
  <div className={styles.container}>
    <h2 className={styles.title}>Invoice Summary</h2>
    <p>Total Invoices Submitted: {totalInvoices} </p>
    {/* <p>Total Reimbursed Amount: {totalReimbursedAmount} </p>
    <p>Unpaid Amount for this period: {unpaidAmount} </p> */}
  </div>
);
};

export default InvoiceSummary;